import { render, staticRenderFns } from "./ListDeposit.vue?vue&type=template&id=85da4754&scoped=true"
import script from "./ListDeposit.vue?vue&type=script&lang=ts"
export * from "./ListDeposit.vue?vue&type=script&lang=ts"
import style0 from "./ListDeposit.vue?vue&type=style&index=0&id=85da4754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da4754",
  null
  
)

export default component.exports